import React from 'react';
import TricolourTribute2024 from 'views/TricolourTribute2024';

const MathClubPage = () => {
  return <TricolourTribute2024/>;
};

export default MathClubPage;

